module.exports = __webpack_public_path__ + "static/img/qrcode@2x.d2f725c9.png";